import React from "react";
import {
    Button,
    Col,
    Row,
    Input,
    Card,
    Divider,
    Form, Spin, message, notification, Tooltip
} from "antd";
import SupportedResourceCard from "./supportedResourceCard";
import {API} from "../../api";
import {withRouter} from "react-router-dom";
import QAViewWrapper from "./QAViewWrapper";
import {_getMappingData, handleError} from "../../utils/util";


message.config({
    duration: 3,
    maxCount: 3,
    rtl: false
});

class PatientViewer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            client_id: !!sessionStorage.getItem(`${this.props.client.id}_client_id`) ? sessionStorage.getItem(`${this.props.client.id}_client_id`) : null,
            client_secret: !!sessionStorage.getItem(`${this.props.client.id}_client_secret`) ? sessionStorage.getItem(`${this.props.client.id}_client_secret`) : null,
            resourceId: !!sessionStorage.getItem(`${this.props.client.id}_resourceId`) ? sessionStorage.getItem(`${this.props.client.id}_resourceId`) : null,
            loading: false,
            selectedResource: {
                "resourceName": "None"
            },
            availableResources: [],
            currResourceList: [],
            fhirResources: [],
            filteredRes: [],
            mappings: [],
            resourceType: null,
            namespace: null,
            version: null,
            resourceCounts: {},
            allFhirResources: {},
            allFilteredFhirResources: {},
            allMappings: {},
            isValid: false,
            search_filter: "",
            patientName: ""
        }
    }

    componentDidMount = async () => {
        this.setState({
            availableResources: [],
            currResourceList: [],
            fhirResources: [],
            mappings: [],
            allFhirResources: {},
            allMappings: {},
            resourceCounts: {},
            patientName: ""
        })
        if (this.state.client_id !== null && this.state.client_secret !== null) {
            await this.testCredentials();
        }
    }

    testCredentials = async () =>{
        const body = {
            "client_id": this.state.client_id,
            "client_secret": this.state.client_secret,
            "client_mapping_id": this.props.client.id,
            "resourceType": "Patient"
        }
        await API.post('/relay/fhir', body).then(() => {
            this.setState({
                isValid: true
            })
        }).catch(() => {
            this.setState({
                loading: false,
                client_id: "",
                client_secret: "",
                isValid: false
            })
            notification.error({
                message: "ERROR:",
                description:  `Client ID/Client Secret not found. Try again.`,
                duration: 6
            });
        })
    }

    getMappings = async (resource) => {
        let resourceType = this.getResourceType(resource);
        let res = await _getMappingData(this.props.client.id,
            'latest',
            resource.resourcetype,
            resource.namespace).catch(error => handleError(error))
        let mappings = this.state.allMappings;
        mappings[resourceType] = res.data.mappings;
        this.setState({allMappings: mappings})
    }

    getResources = async () => {
        this.setState({loading: true});
        const body = {
            "client_id": this.state.client_id,
            "client_secret": this.state.client_secret,
            "client_mapping_id": this.props.client.id,
            "resourceId": this.state.resourceId,
        }
        let res = await API.post('/relay/patient', body).catch(error => {
            handleError(error)
        })
        this.setState({availableResources: Object.keys(res.data.entry)})

        if (res.data.total === 0){
            notification.error({
                message: "ERROR:",
                description: `No patient found with ID, ${this.state.resourceId}, Please try again.`,
                duration: 6
            })
        } else {
            for (let resource of this.state.availableResources) {
                let r = {
                    "resourceName": resource,
                    "type": "",
                    "HL7": `http://hl7.org/fhir/${resource}.html`,
                    "resourcetype": resource,
                    "namespace": "",
                    "ig": null
                }
                let resList = [...this.state.currResourceList, r];
                // Ensures Patient is first resource listed
                if (resource === "Patient"){
                    resList = [r, ...this.state.currResourceList]
                }
                this.setState({currResourceList: resList}, () => {
                    this.addResToState(res.data.entry, r)
                })
                await this.getMappings(r)
            }
        }
    }

    getResourceType(resource){
        let resourceType = resource.resourcetype;
        let type = resource.resourceName.split(' ').slice(-1);
        if(resourceType === "ExplanationOfBenefit"){
            resourceType = resourceType + "?type.coding.code=" + type;
        }
        return resourceType;
    }

    addResToState(entry, resource){
        let resourceType = this.getResourceType(resource);
        let type = resourceType;
        if ( resourceType.startsWith("ExplanationOfBenefit") ){
            type = 'EOB' + resourceType.split('=').slice(-1)
        }
        if (resourceType === "Patient"){
            this.setState({patientName: entry[type]["resources"][0]["resource"]["name"][0]["text"]})
        }
        let fhir = this.state.allFhirResources;
        fhir[resourceType] = entry[type]["resources"] === undefined ? [] : entry[type]["resources"];
        let counts = this.state.resourceCounts
        counts[resourceType] = fhir[resourceType].length;
        this.setState({
            allFhirResources: fhir,
            allFilteredFhirResources: fhir,
            resourceCounts: counts
        })

    }

    onFinish = async(values) => {
        this.setState({
            client_id: values.client_id,
            client_secret: values.client_secret,
            resourceId: values.resourceId,
            base_url: values.base_url,
            availableResources: [],
            currResourceList: [],
            fhirResources: [],
            mappings: [],
            allFhirResources: {},
            allMappings: {},
            resourceCounts: {},
            patientName: "",
            loading: true
        }, () => {
            sessionStorage.setItem(`${this.props.client.id}_client_id`, values.client_id)
            sessionStorage.setItem(`${this.props.client.id}_client_secret`, values.client_secret)
            sessionStorage.setItem(`${this.props.client.id}_resourceId`, values.resourceId)
        })
        await this.testCredentials();
        if (this.state.isValid){
            await this.getResources().then(
                this.setState({
                    selectedResource: {
                        "resourceName": "None"
                    }
                }, () => {})
            );
        }
        this.setState({loading: false})
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    onFilter = async (value) => {
        if(value.search_filter !== "") {
            let result = {};
            for (const [key] of Object.entries(this.state.allFhirResources)) {
                result[key] = [];
                for (let i in this.state.allFhirResources[key]) {
                    let resStr = JSON.stringify(this.state.allFhirResources[key][i]['resource']).toLocaleLowerCase();
                    if (resStr.includes(value.search_filter.toLocaleLowerCase())) {
                        result[key].push(this.state.allFhirResources[key][i])
                    }
                }
            }

            let counts = this.state.resourceCounts
            for (const [key] of Object.entries(this.state.allFhirResources)) {
                counts[key] = result[key].length;
            }
            this.setState({
                filteredRes: result,
                allFilteredFhirResources: result,
                currentPage: 0,
                isModalVisible: false,
                resourceCounts: counts,
                selectedResource: {
                    "resourceName": "None"
                }
            }, () => {})
        } else {
            this.handleClear();
        }
    }

    handleClear = () => {
        let counts = this.state.resourceCounts
        for (const [key] of Object.entries(this.state.allFhirResources)) {
            counts[key] = this.state.allFhirResources[key].length;
        }
        this.setState({
            search_filter: "",
            isModalVisible: false,
            filteredRes: this.state.allFhirResources,
            allFilteredFhirResources: this.state.allFhirResources,
            currentPage: 0,
            selectedResource: {
                "resourceName": "None"
            },
            resourceCounts: counts
        }, () => {});
    };

    setSelectedResource = async(selectedResource) => {
        let resourceType = this.getResourceType(selectedResource);
        this.setState({
            selectedResource,
            loading:false,
            mappings: this.state.allMappings[resourceType],
            fhirResources: this.state.allFhirResources[resourceType],
            filteredRes:  this.state.allFilteredFhirResources[resourceType],
            resourceType: (this.state.allFhirResources[resourceType].length > 0) ? this.state.allFhirResources[resourceType][0].resourceType : null,
            namespace: (this.state.allFhirResources[resourceType].length > 0) ? this.state.allFhirResources[resourceType][0].namespace : null,
            version: (this.state.allFhirResources[resourceType].length > 0) ? this.state.allFhirResources[resourceType][0].version : null
        })
    }

    render() {
        return (
            <>
                <Row align="middle" gutter={[24, 16]}>
                    <Col>
                        <Form
                            name="basic"
                            layout="inline"
                            initialValues={{remember: true}}
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                            autoComplete="off"
                        >
                        <Form.Item
                            name="base_url"
                            initialValue={this.props.client.fhir_api_url}
                        >
                            <Input disabled
                                   addonBefore="FHIR API URL: "/>
                        </Form.Item>
                            <Form.Item
                                name="client_id"
                                initialValue={this.state.client_id}
                                rules={[{required: true, message: 'Please input a client_id'}]}
                            >
                                <Input className="data-qa-input-width"
                                       addonBefore="Client ID: "/>
                            </Form.Item>
                            <Form.Item
                                name="client_secret"
                                initialValue={this.state.client_secret}
                                rules={[{required: true, message: 'Please input a client_secret'}]}
                            >
                                <Input.Password className="data-qa-input-width"
                                       addonBefore="Client Secret: "/>
                            </Form.Item>
                            <Form.Item
                                name="resourceId"
                                initialValue={this.state.resourceId}
                                rules={[{required: true, message: 'Please input a patient identifier'}]}
                            >

                                <Input.Password className="data-qa-input-width"
                                       addonBefore={<Tooltip title="This value should be the Patient resource identifier (e.g. FAKEkOemLh1xavfmABCFNx0zZFPjgPxl1vV6Bef1up). You may also
                                        use the original patient id used at the time of ingest used to generate the resource identifier. In many cases this is the official unique member number,
                                        as listed in the identifiers array in the Patient resource."
                                                             placement="bottom">
                                            Patient ID:
                                       </Tooltip>}/>
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    data-cy="patient-viewer-search-btn"
                                    loading={this.state.loading}>
                                    Search
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <Divider style={{marginTop: 0}}/>
                <Row gutter={[24, 16]}>
                    <Col span={4}>
                        <Card title="Patient Resources" className="supported-resources">
                            {
                                (this.state.currResourceList.length !== this.state.availableResources.length || this.state.currResourceList.length === 0) && ""
                            }
                            {   (this.state.currResourceList.length === this.state.availableResources.length &&
                                this.state.currResourceList.length > 0) &&
                                this.state.currResourceList.map((resource) => {
                                return <SupportedResourceCard key={Math.random()}
                                                              resource={resource}
                                                              selectedResource={this.state.selectedResource}
                                                              setSelectedResource={this.setSelectedResource}
                                                              getResourceType={this.getResourceType}
                                                              count={this.state.resourceCounts}
                                />
                            })}
                        </Card>
                    </Col>
                    <Col span={20}>
                        <Card>
                            <Row>
                                <h4>Patient: <b style={{color: '#1890ff'}}>{this.state.patientName}</b></h4>
                                <Col style={{position: 'absolute', right: '0', marginRight: '25px'}}>
                                <Form
                                    name="basic"
                                    layout="inline"
                                    initialValues={{remember: false}}
                                    onValuesChange={this.onFilter}
                                    autoComplete="off"
                                >
                                    <Row>
                                    <Form.Item
                                        name="search_filter"
                                        initialValue={this.state.search_filter}
                                        style={{width:'100%'}}
                                    >
                                        <Input style={{width:'100%'}}
                                            addonBefore={<Tooltip title="Search for any matching keys/values returned
                                                                        from all resources specific to this patient."
                                                        placement="bottom">
                                                        Filter:
                                        </Tooltip>}/>
                                    </Form.Item>
                                    </Row>
                                </Form>
                                </Col>
                                <Divider/>
                            </Row>
                            {
                                this.state.loading && <Spin />
                            }
                            {
                                this.state.selectedResource.resourceName === "None" && ""
                            }
                            {
                                !this.state.loading && 
                                (this.state.currResourceList.length === this.state.availableResources.length &&
                                this.state.currResourceList.length > 0) &&
                                this.state.selectedResource.resourceName !== "None" &&
                                <QAViewWrapper
                                    resource={this.state.filteredRes}
                                    key={Math.random()}
                                    showPagination={true}
                                    type={this.state.selectedResource.resourceName}
                                    selectedResource={null}
                                    mappings={this.state.mappings}
                                    resourcetype={this.state.resourceType}
                                    namespace={this.state.namespace}
                                    version={this.state.version}
                                    client={this.state.client}
                                    reference={true}
                                />
                            }
                        </Card>
                    </Col>
                </Row>
            </>
        )
    }
}

export default withRouter(PatientViewer);